document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".vt-slider");

  if (!slider) return;

  const swiper = new Swiper(".vt-slider", {

    slidesPerView: 1.2,

    spaceBetween: 20,

    centeredSlides: true,

    loop: true,

    speed: 600,

    watchSlidesProgress: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    breakpoints: {

      768: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },

      1200: {
        slidesPerView: 5,
        centeredSlides: true,
        loop: true,
        spaceBetween:30
      }

    },

    on: {

      init: function () {
        playActiveVideo(this);
      },

      slideChangeTransitionEnd: function () {
        playActiveVideo(this);

      }

    }

  });


  function playActiveVideo(swiper) {

    document.querySelectorAll(".vt-video").forEach(function (video) {

      video.pause();

      video.currentTime = 0;

      const btn = video.closest(".video-card").querySelector(".video-play");

      if (btn) {

        btn.classList.remove("hide");

        btn.innerHTML = "▶";

      }

    });



    const activeSlide = swiper.slides[swiper.activeIndex];

    if (!activeSlide) return;



    const activeVideo = activeSlide.querySelector(".vt-video");



    if (activeVideo) {

      activeVideo.muted = true;

      activeVideo.play().catch(function () {});



      const btn = activeSlide.querySelector(".video-play");

      if (btn) {

        btn.classList.add("hide");

      }

    }

  }





  document.querySelectorAll(".video-card").forEach(function(card){

      const video = card.querySelector(".vt-video");

      const button = card.querySelector(".video-play");



      if(!video) return;



      card.addEventListener("click",function(){



          if(video.paused){

              video.play();

              button.classList.add("hide");

          }else{

              video.pause();

              button.classList.remove("hide");

          }



      });



      video.addEventListener("ended",function(){
        swiper.slideNext();
       button.classList.remove("hide");

      });



      video.addEventListener("pause",function(){

          button.classList.remove("hide");

      });



      video.addEventListener("play",function(){

          button.classList.add("hide");

      });



  });

});

